"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _ahooks = require("ahooks");

var _reactResponsive = require("react-responsive");

var _reactRouterDom = require("react-router-dom");

var _Icon = _interopRequireDefault(require("../../../../../Icon"));

var _StyledLayout = require("../../../../../StyledLayout");

var _constants = require("../../../../constants/constants");

var _ImageLayout = _interopRequireDefault(require("../../../Moodie/components/Grid/ImageLayout"));

var _helpers = require("../../../../../../lib/helpers");

var _StyledTypography = require("../../../../../StyledTypography");

var _Elements = require("../../../../Elements");

var _Elements2 = require("../Folder/Elements");

var _Elements3 = require("./Elements");

var _Elements4 = require("../../../Adams/views/Gallery/Elements");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable react-hooks/exhaustive-deps */
var NewtonGallery = function NewtonGallery(_ref) {
  var _gallery$photos, _gallery$photos$edges;

  var folders = _ref.folders,
      publicUrl = _ref.publicUrl,
      colour = _ref.colour,
      webpSupported = _ref.webpSupported;

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      sliderBoxHeight = _useState2[0],
      setSliderBoxHeight = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      showMore = _useState4[0],
      setShowMore = _useState4[1];

  var isDesktopSmall = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 1152px)'
  });
  var isTabletPortrait = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 768px)'
  });
  var isMobileLandScape = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 667px)'
  });
  var sliderBoxRef = (0, _react.useRef)(null);
  var scrollBoxRef = (0, _react.useRef)(null);

  var _useParams = (0, _reactRouterDom.useParams)(),
      legacyId = _useParams.legacyId;

  var currentGalleryIndex = folders.findIndex(function (item) {
    return item.id === legacyId;
  });
  var gallery = folders[currentGalleryIndex]; // eslint-disable-next-line max-len

  var nextGalleryId = folders.length - 1 > currentGalleryIndex ? folders[currentGalleryIndex + 1].id : undefined;
  var prevGalleryId = currentGalleryIndex > 0 ? folders[currentGalleryIndex - 1].id : undefined;
  var gridLayoutPhotos = (_gallery$photos = gallery.photos) === null || _gallery$photos === void 0 ? void 0 : (_gallery$photos$edges = _gallery$photos.edges) === null || _gallery$photos$edges === void 0 ? void 0 : _gallery$photos$edges.reduce(function (acc, cur) {
    var _cur$node, _cur$node2, _cur$node3, _cur$node3$images;

    var temp = {};
    temp.height = cur === null || cur === void 0 ? void 0 : (_cur$node = cur.node) === null || _cur$node === void 0 ? void 0 : _cur$node.height;
    temp.width = cur === null || cur === void 0 ? void 0 : (_cur$node2 = cur.node) === null || _cur$node2 === void 0 ? void 0 : _cur$node2.width;
    temp.url = cur === null || cur === void 0 ? void 0 : (_cur$node3 = cur.node) === null || _cur$node3 === void 0 ? void 0 : (_cur$node3$images = _cur$node3.images) === null || _cur$node3$images === void 0 ? void 0 : _cur$node3$images[0].url;
    return acc.concat(temp);
  }, []);

  var _useThrottleFn = (0, _ahooks.useThrottleFn)(function (e) {
    var _scrollBoxRef$current, _scrollBoxRef$current2;

    var offset = Math.abs(e.deltaX) >= Math.abs(e.deltaY) ? e.deltaX : e.deltaY; // eslint-disable-next-line no-unused-expressions

    // eslint-disable-next-line no-unused-expressions
    scrollBoxRef === null || scrollBoxRef === void 0 ? void 0 : (_scrollBoxRef$current = scrollBoxRef.current) === null || _scrollBoxRef$current === void 0 ? void 0 : _scrollBoxRef$current.scrollTo((scrollBoxRef === null || scrollBoxRef === void 0 ? void 0 : (_scrollBoxRef$current2 = scrollBoxRef.current) === null || _scrollBoxRef$current2 === void 0 ? void 0 : _scrollBoxRef$current2.scrollLeft) + offset * 40, 0);
  }, {
    wait: 100
  }),
      run = _useThrottleFn.run; // eslint-disable-next-line consistent-return


  var handleScroll = function handleScroll(e) {
    e.preventDefault();
    run(e);
  };

  (0, _react.useEffect)(function () {
    var _sliderBoxRef$current, _scrollBoxRef$current3;

    if (sliderBoxRef !== null && sliderBoxRef !== void 0 && (_sliderBoxRef$current = sliderBoxRef.current) !== null && _sliderBoxRef$current !== void 0 && _sliderBoxRef$current.clientHeight) {
      // 76 is theme topnav height, 72 is Modal component title height
      setSliderBoxHeight(window.innerHeight - 76 - 72);
    } // eslint-disable-next-line no-unused-expressions


    scrollBoxRef === null || scrollBoxRef === void 0 ? void 0 : (_scrollBoxRef$current3 = scrollBoxRef.current) === null || _scrollBoxRef$current3 === void 0 ? void 0 : _scrollBoxRef$current3.addEventListener('wheel', handleScroll);
    return function () {
      var _scrollBoxRef$current4;

      return scrollBoxRef === null || scrollBoxRef === void 0 ? void 0 : (_scrollBoxRef$current4 = scrollBoxRef.current) === null || _scrollBoxRef$current4 === void 0 ? void 0 : _scrollBoxRef$current4.removeEventListener('wheel', handleScroll);
    };
  }, []);
  (0, _react.useEffect)(function () {
    var _scrollBoxRef$current5, _scrollBoxRef$current6;

    // eslint-disable-next-line no-unused-expressions
    scrollBoxRef === null || scrollBoxRef === void 0 ? void 0 : (_scrollBoxRef$current5 = scrollBoxRef.current) === null || _scrollBoxRef$current5 === void 0 ? void 0 : _scrollBoxRef$current5.scrollTo(0, 0, 300); // eslint-disable-next-line no-unused-expressions

    scrollBoxRef === null || scrollBoxRef === void 0 ? void 0 : (_scrollBoxRef$current6 = scrollBoxRef.current) === null || _scrollBoxRef$current6 === void 0 ? void 0 : _scrollBoxRef$current6.focus();
  }, [legacyId]);
  var layoutConfig = (0, _react.useMemo)(function () {
    if (isMobileLandScape) {
      return {
        columns: 2,
        columnWidth: 330,
        gutter: 8
      };
    }

    return {
      columns: 1,
      columnWidth: window.innerWidth,
      gutter: 8
    };
  }, [isMobileLandScape, window.innerWidth]);

  var renderClipText = function renderClipText() {
    var isMobile = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return /*#__PURE__*/_react["default"].createElement(_Elements4.ClipTextBox, {
      mb: "sm",
      showMore: showMore,
      style: {
        maxWidth: isMobile ? 'calc(100% + 200px)' : '100%'
      }
    }, /*#__PURE__*/_react["default"].createElement(_Elements4.ClipPlaceholder, null), /*#__PURE__*/_react["default"].createElement(_Elements4.ClipTextContent, {
      portfolioFontFamily: true,
      portfolioForeground1: true
    }, gallery.description), !showMore && /*#__PURE__*/_react["default"].createElement(_Elements4.ClipTextMore, {
      portfolioFontFamily: true,
      portfolioForeground1: true,
      onClick: function onClick() {
        setShowMore(true);
      }
    }, "...\xA0", /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
      portfolioForeground1: true,
      underline: true,
      as: "span"
    }, "show more")));
  };

  var slideHeight = sliderBoxHeight - 68;

  if (isTabletPortrait) {
    var _gallery$photos2, _gallery$photos2$edge;

    return /*#__PURE__*/_react["default"].createElement(_Elements2.StyledSliderBox, {
      isDesktopSmall: isDesktopSmall,
      ref: sliderBoxRef
    }, /*#__PURE__*/_react["default"].createElement(_Elements2.ScrollBox, {
      tabIndex: "0",
      ref: scrollBoxRef,
      isDesktopSmall: isDesktopSmall
    }, /*#__PURE__*/_react["default"].createElement(_Elements3.StyledDescriptionBox, {
      justify: "center",
      column: true,
      height: slideHeight
    }, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
      portfolioForeground1: true
    }, gallery.description), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: publicUrl
    }, /*#__PURE__*/_react["default"].createElement(_Elements3.StyledBackBox, {
      flex: true,
      align: "center",
      pointer: true,
      mt: "md",
      colour: _constants.PORTFOLIO_THEME_COLOR[colour]
    }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      svg: "chevronLeft"
    }), /*#__PURE__*/_react["default"].createElement(_StyledTypography.Paragraph, {
      ml: "xxs",
      portfolioForeground1: true
    }, "Back")))), (_gallery$photos2 = gallery.photos) === null || _gallery$photos2 === void 0 ? void 0 : (_gallery$photos2$edge = _gallery$photos2.edges) === null || _gallery$photos2$edge === void 0 ? void 0 : _gallery$photos2$edge.map(function (photo) {
      var _photo$node, _photo$node2, _photo$node5, _photo$node6;

      var imgStyle = {};

      if ((photo === null || photo === void 0 ? void 0 : (_photo$node = photo.node) === null || _photo$node === void 0 ? void 0 : _photo$node.width) > (photo === null || photo === void 0 ? void 0 : (_photo$node2 = photo.node) === null || _photo$node2 === void 0 ? void 0 : _photo$node2.height)) {
        imgStyle.height = slideHeight;
      } else {
        var _photo$node3, _photo$node4;

        imgStyle.height = slideHeight;
        imgStyle.width = slideHeight * (photo === null || photo === void 0 ? void 0 : (_photo$node3 = photo.node) === null || _photo$node3 === void 0 ? void 0 : _photo$node3.width) / (photo === null || photo === void 0 ? void 0 : (_photo$node4 = photo.node) === null || _photo$node4 === void 0 ? void 0 : _photo$node4.height);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        key: photo === null || photo === void 0 ? void 0 : (_photo$node5 = photo.node) === null || _photo$node5 === void 0 ? void 0 : _photo$node5.legacyId
      }, /*#__PURE__*/_react["default"].createElement(_Elements2.StyledSlideImageMainBox, {
        height: slideHeight,
        flex: true,
        align: "center"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        alt: "",
        style: imgStyle,
        onContextMenu: function onContextMenu(e) {
          return e.preventDefault();
        },
        src: (0, _helpers.getImageByFormat)(photo === null || photo === void 0 ? void 0 : (_photo$node6 = photo.node) === null || _photo$node6 === void 0 ? void 0 : _photo$node6.images[0], webpSupported)
      })));
    }), nextGalleryId && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
      to: "".concat(publicUrl, "/gallery/").concat(nextGalleryId)
    }, /*#__PURE__*/_react["default"].createElement(_Elements3.StyledNextGalleryBox, {
      flex: true,
      align: "center",
      height: slideHeight,
      pointer: true,
      colour: _constants.PORTFOLIO_THEME_COLOR[colour]
    }, /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
      large: true,
      portfolioForeground1: true,
      mr: "xs"
    }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "portfolio.theme.gallery.next_gallery"
    })), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      svg: "chevronRight"
    })))));
  }

  return /*#__PURE__*/_react["default"].createElement(_Elements2.StyledMobileFolderList, {
    style: {
      padding: '76px 0 72px'
    }
  }, gallery !== null && gallery !== void 0 && gallery.name ? /*#__PURE__*/_react["default"].createElement(_StyledTypography.HeadingLarge, {
    portfolioFontFamily: true,
    portfolioForeground1: true,
    normal: true,
    mb: "md",
    center: true
  }, gallery.name) : null, renderClipText(true), /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    justify: "center"
  }, /*#__PURE__*/_react["default"].createElement(_ImageLayout["default"], (0, _extends2["default"])({}, layoutConfig, {
    photos: gridLayoutPhotos
  }))), /*#__PURE__*/_react["default"].createElement(_Elements4.MobilePortraitGalleryChangeBox, {
    flex: true,
    align: "center",
    justify: !prevGalleryId ? 'right' : 'space-between',
    px: "sm"
  }, prevGalleryId && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "".concat(publicUrl, "/gallery/").concat(prevGalleryId),
    onClick: function onClick() {
      window.scrollTo(0, 0);
    }
  }, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "chevronLeft"
  }), /*#__PURE__*/_react["default"].createElement(_StyledTypography.Paragraph, {
    portfolioFontFamily: true,
    portfolioForeground1: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.gallery.previous_gallery"
  })))), nextGalleryId && /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "".concat(publicUrl, "/gallery/").concat(nextGalleryId),
    onClick: function onClick() {
      window.scrollTo(0, 0);
    }
  }, /*#__PURE__*/_react["default"].createElement(_StyledLayout.Box, {
    flex: true,
    align: "center"
  }, /*#__PURE__*/_react["default"].createElement(_StyledTypography.Paragraph, {
    portfolioFontFamily: true,
    portfolioForeground1: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "portfolio.theme.gallery.next_gallery"
  })), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "chevronRight"
  })))));
};

NewtonGallery.defaultProps = {
  publicUrl: '',
  colour: '',
  webpSupported: false
};
NewtonGallery.propTypes = {
  folders: _propTypes["default"].arrayOf(_propTypes["default"].shape()).isRequired,
  publicUrl: _propTypes["default"].string,
  colour: _propTypes["default"].string,
  webpSupported: _propTypes["default"].bool
};
var _default = NewtonGallery;
exports["default"] = _default;